import { render, staticRenderFns } from "./OweeCis.vue?vue&type=template&id=0227df1a&scoped=true&"
import script from "./OweeCis.vue?vue&type=script&lang=ts&"
export * from "./OweeCis.vue?vue&type=script&lang=ts&"
import style0 from "./OweeCis.vue?vue&type=style&index=0&id=0227df1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0227df1a",
  null
  
)

export default component.exports